// 微应用
export default [
  {
    path: '/micro',
    title: '微应用',
    component: () => import('../views/micro/micro-router.vue')
  }
]
